// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tasks-table .filter-none .custom-btn .p-button.p-button-outlined {
  border-color: #e24c4c;
}

#tags-scroll::-webkit-scrollbar-track {
  border-radius: 10px;
}

#tags-scroll::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

#tags-scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.3);
  background-color: rgb(225, 234, 245);
}

@media (min-width: 1160px) {
  .mainTab-task-card {
    margin-bottom: -25px;
  }
}

#custom-cardscroll::-webkit-scrollbar-track {
  border-radius: 5px;
}

#custom-cardscroll::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

#custom-cardscroll::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.3);
  background-color: rgb(225, 234, 245);
}

.p-card.p-component {
  padding-bottom: 0;
}

.actualJobs-table
  .p-datatable-thead
  [data-pc-section='headerrow']:nth-child(2) {
  height: 57px;
}

@media (max-width: 1160px) {
  .tasks-table #table-header { 
    flex-wrap: wrap;
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .tasks-table .p-datatable-header {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }
}

.tasks-table .tasks-date-header .p-column-header-content {
  align-items: flex-start;
}

.tasks-table .tasks-date-header .p-column-title {
  white-space: normal;
  line-height: 1.15;
  min-width: 0;
}

.mobile-table-header {
  padding: 12px 0;
  background: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 12px;
}

.mobile-header-main {
  display: flex;
  gap: 8px;
  align-items: center;
}

.mobile-search {
  flex: 1 1;
  min-width: 0;
}

.mobile-search .p-input-icon-left {
  width: 100%;
}

.mobile-search input {
  width: 100%;
  padding: 10px 10px 10px 32px;
  border-radius: 4px;
  border: 1px solid #ced4da;
  font-size: 14px;
}

.mobile-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.mobile-filters-dialog .p-dialog-content {
  padding: 16px;
}

.mobile-filters-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mobile-filter-section h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
}

.mobile-filter-section .p-inputtext {
  width: 100%;
}

.mobile-control-buttons-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(45px, 1fr));
  gap: 8px;
}

.mobile-control-buttons-grid .p-button {
  width: 100%;
}

@media (max-width: 768px) {
  .tasks-table .p-datatable-header {
    padding: 8px;
  }
}

@media (max-width: 480px) {
  .mobile-actions .p-button {
    width: 36px;
    height: 36px;
  }
  
  .mobile-actions .p-button .p-button-icon {
    font-size: 14px;
  }
  
  .mobile-search input {
    font-size: 13px;
    padding: 8px 8px 8px 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui/css/Tasks.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0DAA0D;EAC1D,oCAAoC;AACtC;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,0DAA0D;EAC1D,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;EACnC;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;AACF","sourcesContent":[".tasks-table .filter-none .custom-btn .p-button.p-button-outlined {\n  border-color: #e24c4c;\n}\n\n#tags-scroll::-webkit-scrollbar-track {\n  border-radius: 10px;\n}\n\n#tags-scroll::-webkit-scrollbar {\n  width: 12px;\n  background-color: #f5f5f5;\n}\n\n#tags-scroll::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.3);\n  background-color: rgb(225, 234, 245);\n}\n\n@media (min-width: 1160px) {\n  .mainTab-task-card {\n    margin-bottom: -25px;\n  }\n}\n\n#custom-cardscroll::-webkit-scrollbar-track {\n  border-radius: 5px;\n}\n\n#custom-cardscroll::-webkit-scrollbar {\n  width: 6px;\n  background-color: #f5f5f5;\n}\n\n#custom-cardscroll::-webkit-scrollbar-thumb {\n  border-radius: 5px;\n  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.3);\n  background-color: rgb(225, 234, 245);\n}\n\n.p-card.p-component {\n  padding-bottom: 0;\n}\n\n.actualJobs-table\n  .p-datatable-thead\n  [data-pc-section='headerrow']:nth-child(2) {\n  height: 57px;\n}\n\n@media (max-width: 1160px) {\n  .tasks-table #table-header { \n    flex-wrap: wrap;\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 768px) {\n  .tasks-table .p-datatable-header {\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n.tasks-table .tasks-date-header .p-column-header-content {\n  align-items: flex-start;\n}\n\n.tasks-table .tasks-date-header .p-column-title {\n  white-space: normal;\n  line-height: 1.15;\n  min-width: 0;\n}\n\n.mobile-table-header {\n  padding: 12px 0;\n  background: #f8f9fa;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}\n\n.mobile-header-main {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.mobile-search {\n  flex: 1;\n  min-width: 0;\n}\n\n.mobile-search .p-input-icon-left {\n  width: 100%;\n}\n\n.mobile-search input {\n  width: 100%;\n  padding: 10px 10px 10px 32px;\n  border-radius: 4px;\n  border: 1px solid #ced4da;\n  font-size: 14px;\n}\n\n.mobile-actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.mobile-filters-dialog .p-dialog-content {\n  padding: 16px;\n}\n\n.mobile-filters-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.mobile-filter-section h4 {\n  margin: 0 0 8px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.mobile-filter-section .p-inputtext {\n  width: 100%;\n}\n\n.mobile-control-buttons-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(45px, 1fr));\n  gap: 8px;\n}\n\n.mobile-control-buttons-grid .p-button {\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .tasks-table .p-datatable-header {\n    padding: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .mobile-actions .p-button {\n    width: 36px;\n    height: 36px;\n  }\n  \n  .mobile-actions .p-button .p-button-icon {\n    font-size: 14px;\n  }\n  \n  .mobile-search input {\n    font-size: 13px;\n    padding: 8px 8px 8px 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
